import { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { formatDate } from "../../components/CommonDateFormat";
import {
  usePendingTrQuery,
  useUpdatePendingStatusMutation,
} from "../../features/api/transactionApi";
import { toast } from "react-toastify";

const PendingCollection = () => {
  const { data, isLoading } = usePendingTrQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  // Search Term Start
  const [searchTerm, setInputValue] = useState("");
  const searchResults = data?.filter((option) => {
    if (option && typeof option === "object") {
      return Object.values(option).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        }
      });
    } else {
      return false;
    }
  });
  // Search Term End

  const [updatePendingStatus] = useUpdatePendingStatusMutation();
  const handleUpdate = async (id) => {
    const confirm = window.confirm("Are you sure you want to approve?");
    if (confirm) {
      const res = await updatePendingStatus({ id: id, status: 1 });
      console.log(res);
      if (!res?.error) {
        toast.success(res?.data?.message);
      } else {
        toast.error("Error....");
      }
    }
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div className="">
      <div className="flex justify-between items-center px-12 py-6">
        <h1 className="text-xl font-bold">Pending Collections</h1>
      </div>
      <input
        type="text"
        placeholder="Search..."
        className="border border-gray-400 ml-12 focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className="h-[71vh] overflow-auto w-full m-auto px-12 my-5">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : data?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">No pending datas</p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Date</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Transaction</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Collection By</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Client</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Amount</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    return (
                      <TableRow key={row?.id}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{formatDate(row?.trDate)}</TableCell>
                        <TableCell>{row?.jv_no}</TableCell>
                        <TableCell>{row?.name}</TableCell>
                        <TableCell>{row?.client}</TableCell>
                        <TableCell>{row?.amount}</TableCell>
                        <TableCell>
                          <button
                            onClick={() => handleUpdate(row?.id)}
                            className="text-blue-600 font-bold border border-blue-700 px-1 rounded-sm"
                          >
                            Approve
                          </button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[20, 30, 50]}
              component="div"
              count={data?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default PendingCollection;
